let reportAdminForm = {
    $form: $('#js-reportAdminForm'),
    $notifications: $('#js-reportAdminForm .js-formNotification'),
    $notificationDeleted: $('#js-reportAdminNotificationDeleted'),
    $notificationSuccess: $('#js-reportAdminNotificationSuccess'),

    init() {
        this.$form.on('ajaxForm:send', this.onAjaxFormSend.bind(this))
        this.$form.on('ajaxForm:success', this.onAjaxFormSuccess.bind(this))
    },

    onAjaxFormSend(e) {
        this.$notifications.hide()
    },

    onAjaxFormSuccess(e, data) {
        if (data.deleted) {
            this.$notificationDeleted.show()
        } else {
            this.$notificationSuccess.show()
        }
    }
}

export default reportAdminForm